<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Cargos | Criar" />
    <form-role v-model="model" @submit="submit" />
  </section>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import TPageTitle from '@/components/TPageTitle.vue'
import Role from '@/types/Role'
import RoleService from '@/services/RoleService'
import Ability from '@/types/Ability'
import FormRole from './form-role.vue'
import { useRouter } from 'vue-router'

const loader = useLoader()
const snackbar = useSnackBar()
const router = useRouter()

const model = ref<Role>({ title: '', abilities: [] as Ability[] } as Role)

async function submit() {
  try {
    loader.increment()

    const response = await (new RoleService()).store(model.value)

    const role = response.data.data

    snackbar.show(
      'Cargo criado com sucesso',
      'success',
    )

    router.push({ name: 'edit-roles', params: { id: role.id } })
  } finally {
    loader.decrement()
  }
}
</script>
